"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function LinkedinSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 30, viewBox: "0 0 30 30" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { transform: "translate(-118 -743) translate(118 743)" },
            react_1.default.createElement("circle", { cx: 15, cy: 15, r: 12, fill: "#fff" }),
            react_1.default.createElement("path", { fill: "#0077B5", d: "M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm-4.4 12.424H7.201v10.213h3.4V12.424zm8.346-.24c-1.805 0-2.613.991-3.064 1.687v-1.447h-3.4c.012.254.017 1.092.02 2.187v1.94c-.004 2.452-.016 5.2-.02 5.911v.175h3.4v-5.704c0-.305.022-.61.112-.828.245-.61.805-1.241 1.744-1.241 1.23 0 1.722.936 1.722 2.309v5.464h3.4v-5.856c0-3.137-1.677-4.597-3.914-4.597zM8.923 7.5C7.76 7.5 7 8.263 7 9.264c0 .98.738 1.766 1.879 1.766h.022c1.185 0 1.923-.785 1.923-1.766-.022-1.001-.738-1.764-1.9-1.764z" })));
}
function Linkedin(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(LinkedinSvg, Object.assign({}, svgProps)));
}
exports.default = Linkedin;
//# sourceMappingURL=Linkedin.js.map